import { colorGray, fontWeightStrong } from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const GreyString = styled.span`
  font-weight: ${fontWeightStrong};
  margin: 0 4px;
  padding: 4px;
  background-color: ${colorGray[1]};
  border: 1px solid ${colorGray[2]};
  border-radius: 4px;
`;
